import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { config } from "../../utils/config";
import { FaCircleCheck } from "react-icons/fa6";
import { toast } from "react-toastify";
import { tokenDecode } from "../../utils/helper";
import {
    UserOutlined
} from '@ant-design/icons';

export default function BasicDetailsStep({
    data,
    setData,
    getAllbusinessInfo,
    isPANVerified,
    setIsPANVerified,
    verifyPanDetails,
    setIsGSTVerified,
    isGSTVerified,
    setPrefillBasicData,
    prefillBasicData
}) {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const seller_id = query.get("seller_id");
    const client_token = query.get("client_token");
    const state = query.get("state");
    const { apiEndpoint } = config;
    const [isLoading, setIsLoading] = useState(false);
    const [isCheckingAadhar, setIsCheckingAadhar] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Allow digits and masking characters (like x, X, *)
        const sanitizedValue = name === "pan_number" ? value.replace(/[^0-9xX*]/g, "").slice(0, 14) : value;
        if (isPANVerified) {
            setIsPANVerified(false);
        }
        setData({
            ...data,
            [name]: sanitizedValue
        });
    };

    const verifyPanHandler = async () => {
        try {
            setIsLoading(true);
            const res = await verifyPanDetails(data.pan_number);
            console.log("Aadhaar Verify Response --->", res);

            const meonUrl = res?.digi_locker_url?.url || (typeof res?.digi_locker_url === "string" ? res?.digi_locker_url : null) || res?.url || res?.redirect_url || res?.data?.url || res?.response?.data?.digi_locker_url?.url || res?.response?.data?.digi_locker_url;

            if (meonUrl) {
                window.location.replace(meonUrl);
                return;
            }

            if (!res?.digi_locker_url && !res?.status) {
                toast.error(res?.message || res?.error || "Aadhaar verification failed");
                setIsLoading(false);
                return;
            }

            if (res?.status || res?.response?.data) {
                setIsPANVerified(true);
                toast.success("Aadhaar verified successfully! ✅");
                await sendEntireData();
            } else {
                toast.error(res?.message || res?.error || "Verification failed");
            }
        } catch (err) {
            console.log("PAN Error:", err);
            toast.error("Aadhaar verification failed");
        } finally {
            setIsLoading(false);
        }
    };

    const isValidPAN = (pan_number) => {
        const cleaned = (pan_number || "").toString().trim();
        return cleaned.length === 12 || /^[xX*]{8}[0-9]{4}$/.test(cleaned) || cleaned.length >= 10;
    };

    const getEffectiveParams = () => {
        const decoded = tokenDecode();
        const decodedData = decoded?.data || {};
        const userObj = Array.isArray(decodedData?.user) ? decodedData?.user[0] : (decodedData?.user || {});
        const sellerIdFromToken = userObj?.seller_id || decodedData?.seller_id || decodedData?.seller_data?.[0]?.id;

        return {
            seller_id: seller_id ? Number(seller_id) : (sellerIdFromToken ? Number(sellerIdFromToken) : undefined),
            client_token: client_token || sessionStorage.getItem("client_token") || "static_client_token",
            state: state || sessionStorage.getItem("state") || "verified"
        };
    };

    // Check if Aadhaar details already exist in DB / API on initial load
    const checkExistingAadharDetails = async () => {
        try {
            setIsCheckingAadhar(true);
            const token = sessionStorage.getItem("token");
            if (!token) return;

            const res = await axios.post(
                `${apiEndpoint}/snp/verify/get-aadhar-details`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${token}`
                    }
                }
            );

            const resData = res?.data;
            const aadharData = resData?.data || resData?.response?.data || resData;
            const aadharNumber = aadharData?.aadhar_no
                || aadharData?.aadhar_number
                || aadharData?.pan_number
                || resData?.aadhar_no
                || aadharData?.kyc?.aadhar_no
                || aadharData?.non_verify_aadhar;

            const isSuccess = Boolean(resData?.status === true || resData?.status === 200 || resData?.success === true);

            if (isSuccess && aadharNumber) {
                if (setData) {
                    setData((prev) => ({
                        ...(prev || data || {}),
                        pan_number: aadharNumber,
                        aadhar_verified: true
                    }));
                }
                if (setIsPANVerified) {
                    setIsPANVerified(true);
                }
            }
        } catch (error) {
            console.log("Existing aadhar check error:", error?.response?.data?.message || error?.message);
        } finally {
            setIsCheckingAadhar(false);
        }
    };

    const fetchAadharDetails = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const { seller_id: effSellerId, client_token: effClientToken, state: effState } = getEffectiveParams();

            await axios.post(
                `${apiEndpoint}/snp/verify/aadhar-details`,
                {
                    aadhar_no: data?.pan_number,
                    seller_id: effSellerId,
                    client_token: effClientToken,
                    state: effState,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${token}`
                    }
                }
            );
        } catch (error) {
            console.error("Error in aadhar-details API:", error);
        }
    };

    const getBusinessDetails = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const { seller_id: effSellerId, client_token: effClientToken, state: effState } = getEffectiveParams();

            const res = await axios.post(
                `${apiEndpoint}/snp/verify/get-business-details`,
                {
                    aadhar_no: data?.pan_number,
                    seller_id: effSellerId,
                    client_token: effClientToken,
                    state: effState,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${token}`
                    }
                }
            );
            if (res?.data?.response?.data) {
                setData((prev) => ({
                    ...prev,
                    pan_number: res.data?.response?.data?.aadhar_no || prev.pan_number
                }));
                setIsPANVerified(true);
            }
        } catch (error) {
            console.error("Error in get-business-details API:", error);
        }
    };

    const sendEntireData = async () => {
        if (!seller_id || !client_token || !state) return;
        await fetchAadharDetails();
        await getBusinessDetails();
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get("seller_id") && queryParams.get("client_token") && queryParams.get("state")) {
            sendEntireData();
        } else {
            // Auto check if aadhar details already verified/exist from API
            checkExistingAadharDetails();
        }
    }, [location.search]);

    return (
        <>
            <h2 className="h4 mt-5 fw-semibold text-dark mb-0 px-0 pt-0 pb-4" style={{ color: "black", fontSize: "20px", fontWeight: "600" }}>
                KYC Verification and Basic Details
            </h2>
            <div className="shadow-sm p-4 pt-0 rounded rounded-5 border bg-white mt-1">

                <h2 className="h4 fw-semibold text-dark mb-0 px-0 pt-0 pb-4 d-flex align-items-center" style={{ color: "black", fontSize: "20px", fontWeight: "600", gap: "5px" }}>
                    <UserOutlined /> Aadhar Details
                </h2>
                {isPANVerified && data?.pan_number ? (
                    <div className="alert mb-3 alert-success mb-0 p-2 d-flex align-items-center" style={{ gap: "5px", color: "green", background: "#e8f3e8", borderColor: "#2B912B" }}>
                        <FaCircleCheck /> Your aadhar details have been verified successfully.
                    </div>
                ) : null}
                <div>
                    <div className="mb-3 w-100">
                        <label style={{ color: "#64748b", marginBottom: "6px", display: "block", fontSize: "14px", fontWeight: 500 }}>
                            Aadhar Number <span className="text-danger">*</span>
                        </label>

                        <div className="position-relative d-flex align-items-center w-100">
                            <input
                                type="text"
                                name="pan_number"
                                maxLength={12}
                                value={data?.pan_number || ""}
                                onChange={handleChange}
                                className="form-control w-100 text-secondary"
                                placeholder={isCheckingAadhar ? "Checking Aadhaar status..." : "XXXX XXXX XXXX"}
                                disabled={isPANVerified || isCheckingAadhar}
                                style={{
                                    background: "#F3F3F5",
                                    paddingRight: isPANVerified ? "12px" : "95px",
                                    height: "46px",
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    letterSpacing: "1px",
                                    cursor: isPANVerified ? "not-allowed" : "text"
                                }}
                            />
                            {!isPANVerified ? (
                                <button
                                    type="button"
                                    className="btn btn-sm d-flex justify-content-center align-items-center"
                                    onClick={verifyPanHandler}
                                    disabled={isLoading || isCheckingAadhar || !isValidPAN(data?.pan_number)}
                                    style={{
                                        position: "absolute",
                                        right: "5px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        background: "linear-gradient(90deg, #F75710, #FC8809)",
                                        color: "#fff",
                                        border: "none",
                                        outline: "none",
                                        borderRadius: "8px",
                                        opacity: (isLoading || isCheckingAadhar || !isValidPAN(data?.pan_number)) ? 0.6 : 1,
                                        cursor: (isLoading || isCheckingAadhar || !isValidPAN(data?.pan_number)) ? "not-allowed" : "pointer",
                                        width: "82px",
                                        height: "36px",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        zIndex: 2,
                                        boxShadow: "0 2px 6px rgba(247, 87, 16, 0.25)"
                                    }}
                                >
                                    {isLoading ? "Verifying..." : "Verify"}
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
